import React from 'react';

interface ProgressBarProps {
  porcentaje: number;
  estado: 'normal' | 'advertencia' | 'superado';
  showLabel?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  porcentaje,
  estado,
  showLabel = false,
  className = '',
  size = 'md'
}) => {
  const getBarColor = () => {
    switch (estado) {
      case 'superado':
        return 'bg-red-500';
      case 'advertencia':
        return 'bg-yellow-500';
      default:
        return 'bg-green-500';
    }
  };

  const getBackgroundColor = () => {
    switch (estado) {
      case 'superado':
        return 'bg-red-100';
      case 'advertencia':
        return 'bg-yellow-100';
      default:
        return 'bg-green-100';
    }
  };

  const getHeight = () => {
    switch (size) {
      case 'sm':
        return 'h-2';
      case 'lg':
        return 'h-4';
      default:
        return 'h-3';
    }
  };

  const getTextSize = () => {
    switch (size) {
      case 'sm':
        return 'text-xs';
      case 'lg':
        return 'text-base';
      default:
        return 'text-sm';
    }
  };

  const porcentajeMostrado = Math.min(porcentaje, 100);
  const porcentajeReal = porcentaje;

  return (
    <div className={className}>
      {showLabel && (
        <div className={`flex justify-between ${getTextSize()} text-gray-600 mb-2`}>
          <span>Progreso</span>
          <span className={porcentajeReal >= 100 ? 'text-red-600 font-semibold' : ''}>
            {porcentajeReal.toFixed(1)}%
          </span>
        </div>
      )}
      
      <div className={`w-full ${getBackgroundColor()} rounded-full ${getHeight()}`}>
        <div
          className={`${getHeight()} rounded-full transition-all duration-300 ${getBarColor()}`}
          style={{ 
            width: `${porcentajeMostrado}%` 
          }}
        />
      </div>
      
      {/* Indicador visual si se ha superado el 100% */}
      {porcentajeReal > 100 && (
        <div className="flex items-center mt-1">
          <div className="w-full bg-red-200 rounded-full h-1">
            <div
              className="h-1 rounded-full bg-red-600 transition-all duration-300"
              style={{ 
                width: `${Math.min((porcentajeReal - 100) * 2, 100)}%` 
              }}
            />
          </div>
          <span className="text-xs text-red-600 ml-2 font-semibold">
            +{(porcentajeReal - 100).toFixed(1)}%
          </span>
        </div>
      )}
    </div>
  );
};